import type { RadioButtonGroupProps, RadioButtonProps } from '@sunwebgroup/uds-ui/radio-button'
import { RadioButton as CssRadioButton, RadioButtonGroup as CssRadioButtonGroup } from '@sunwebgroup/uds-ui/radio-button'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/radio-button' instead.
 */
export const RadioButtonWrapper = Object.assign(
  styled(CssRadioButton)<RadioButtonProps>``,
  { displayName: 'RadioButton' },
)

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/radio-button' instead.
 */
export const RadioButtonGroupWrapper = Object.assign(
  styled(CssRadioButtonGroup)<RadioButtonGroupProps>``,
  { displayName: 'RadioButtonGroup' },
)
